import { render, staticRenderFns } from "./ConnectionSettingsPopup.vue?vue&type=template&id=d7e61d86&"
import script from "./ConnectionSettingsPopup.vue?vue&type=script&lang=js&"
export * from "./ConnectionSettingsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7e61d86')) {
      api.createRecord('d7e61d86', component.options)
    } else {
      api.reload('d7e61d86', component.options)
    }
    module.hot.accept("./ConnectionSettingsPopup.vue?vue&type=template&id=d7e61d86&", function () {
      api.rerender('d7e61d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/ConnectionSettingsPopup.vue"
export default component.exports